import { createSelector, MemoizedSelector } from '@ngrx/store';
import { CustomSearchResults } from '@search/const';
import { StateUtils } from '@spartacus/core';
import { SearchState, StateWithSearch } from '../search-state';
import { getCustomSearchState } from './feature.selector';

export const getSearchSuggestionsState: MemoizedSelector<
  StateWithSearch,
  StateUtils.LoaderState<CustomSearchResults>
> = createSelector(getCustomSearchState, (state: SearchState) => state.searchSuggestions);

export const getSearchSuggestionsValue: MemoizedSelector<StateWithSearch, CustomSearchResults> = createSelector(
  getSearchSuggestionsState,
  (state: StateUtils.LoaderState<CustomSearchResults>) => StateUtils.loaderValueSelector(state),
);

export const getSearchSuggestionsLoading: MemoizedSelector<StateWithSearch, boolean> = createSelector(
  getSearchSuggestionsState,
  (state: StateUtils.LoaderState<CustomSearchResults>) => StateUtils.loaderLoadingSelector(state),
);

export const getSearchSuggestionsError: MemoizedSelector<StateWithSearch, boolean> = createSelector(
  getSearchSuggestionsState,
  (state: StateUtils.LoaderState<CustomSearchResults>) => StateUtils.loaderErrorSelector(state),
);

export const getSearchSuggestionsSuccess: MemoizedSelector<StateWithSearch, boolean> = createSelector(
  getSearchSuggestionsState,
  (state: StateUtils.LoaderState<CustomSearchResults>) => StateUtils.loaderSuccessSelector(state),
);
